import { v2black, v2white } from '@paypalcorp/pp-react'
import { StyleSheet } from '../../../../../lib/paypalphrodite'
import { mobileAndSmaller } from '../../../../../lib/styles/media-queries'

export const CardStyles = StyleSheet.create({
  container: {
    width: '100%',
    color: v2black,
    backgroundColor: v2white,
    lineHeight: 'normal',
    '-webkit-text-stroke-width': 'unset',
    border: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: '16px',
    padding: 0,
    maxWidth: 500,
  },
  headingText: {
    textAlign: 'center',
    marginBottom: '24px',
  },
  bodyText: {
    padding: '8px 16px',
    textAlign: 'left',
    [mobileAndSmaller]: {
      padding: '0px',
    },
  },
})

export const OverrideStyles = StyleSheet.create({
  acceptSpot: {
    width: '2rem',
    height: '2rem',
    border: 'none',
    padding: 'unset',
    visibility: 'visible',
  },
  purchaseProtectionLink: {
    marginTop: '14px',
    marginBottom: '14px',
    textAlign: 'center',
  },
  acceptSpotHidden: {
    visibility: 'hidden',
  },
  button: {
    [mobileAndSmaller]: {
      width: '100%',
    },
  },
  title: {
    textAlign: 'center',
  },
})
